import { createVNode as _createVNode } from "vue";
/**
 * @author chenjizhong
 * @fileoverview 首页/赛事荣誉榜 > 队员列表
 */
import { defineComponent, toRefs } from "vue";
import ListItem from "@/components/m/member-list/components/list-item.vue";
export default defineComponent({
  name: "MMemberList",
  props: {
    teamData: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(props) {
    const {
      teamData
    } = toRefs(props);
    return () => {
      if (teamData.value.length == 5) {
        return _createVNode("div", {
          "class": "container"
        }, [_createVNode("div", {
          "class": "flex-box"
        }, [teamData.value.slice(0, 2).map(item => {
          return _createVNode(ListItem, {
            "itemInfo": item
          }, null);
        })]), _createVNode("div", {
          "class": "flex-box"
        }, [teamData.value.slice(2, 5).map(item => {
          return _createVNode(ListItem, {
            "itemInfo": item
          }, null);
        })])]);
      } else if (teamData.value.length == 6) {
        return _createVNode("div", {
          "class": "container"
        }, [_createVNode("div", {
          "class": "flex-box"
        }, [teamData.value.map(item => {
          return _createVNode(ListItem, {
            "itemInfo": item
          }, null);
        })])]);
      } else {
        return _createVNode("div", {
          "class": "container"
        }, [_createVNode("div", {
          "class": "flex-box"
        }, [teamData.value.slice(0, 2).map(item => {
          return _createVNode(ListItem, {
            "itemInfo": item
          }, null);
        })]), _createVNode("div", {
          "class": "flex-box"
        }, [teamData.value.slice(2, 5).map(item => {
          return _createVNode(ListItem, {
            "itemInfo": item
          }, null);
        })]), _createVNode("div", {
          "class": "flex-box"
        }, [teamData.value.slice(5, 7).map(item => {
          return _createVNode(ListItem, {
            "itemInfo": item
          }, null);
        })])]);
      }
    };
  }
});